import React from 'react';

const CloneIconNew = ({ iconColor, iconSize, iconDropDownList, clickHandler }) => {
  // If dropdown list exists, render with dropdown (like MeatBall)
  if (iconDropDownList && iconDropDownList.length > 0) {
    return (
      <div className="dropdown" style={{ position: 'static' }}>
        {/* Dropdown Toggle Button */}
        <a
          className="btn btn-icon px-1 btn-transparent-dark noarrow"
          type="button"
          data-bs-toggle="dropdown"
          data-bs-boundary="viewport"
          data-bs-offset="0,5"
          aria-expanded="false"
        >
          {/* SVG Icon */}
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width={iconSize || 16} 
            height={iconSize || 16} 
            viewBox="0 0 48 48"
            fill={iconColor || '#000'}
          >
            <path fill="none" d="M0 0h48v48H0z"></path>
            <path d="M32 2H8C5.79 2 4 3.79 4 6v28h4V6h24V2zm6 8H16c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4V14c0-2.21-1.79-4-4-4zm0 32H16V14h22v28z"></path>
          </svg>
        </a>

        {/* Dropdown Menu */}
        <ul className="dropdown-menu dropdown-menu-end px-0">
          {iconDropDownList.map((item, index) => (
            item.divider ? (
              <li key={index}><hr className="dropdown-divider my-1" /></li>
            ) : (
              <li key={index} className="dropdown-item" onClick={item.clickHandler}>
                <span
                  className="d-flex align-items-center pr-1"
                  title={item.label}
                >
                  {item.label}
                </span>
              </li>
            )
          ))}
        </ul>
      </div>
    );
  }

  // Simple icon with click handler (no dropdown)
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={iconSize || 16} 
      height={iconSize || 16} 
      viewBox="0 0 48 48"
      fill={iconColor || '#000'}
      onClick={clickHandler}
      style={{ cursor: clickHandler ? 'pointer' : 'default' }}
    >
      <path fill="none" d="M0 0h48v48H0z"></path>
      <path d="M32 2H8C5.79 2 4 3.79 4 6v28h4V6h24V2zm6 8H16c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4V14c0-2.21-1.79-4-4-4zm0 32H16V14h22v28z"></path>
    </svg>
  );
};

CloneIconNew.defaultProps = {
  iconColor: '#000',
  iconSize: 16
};

export default CloneIconNew;

